// components/SectionDivider.js
const SectionDivider = () => (
    <hr style={{ borderTop: "1px solid white", margin: "2rem 0", opacity: 0.3 }} />
  );
  
  export default SectionDivider;
  